var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',[_vm._v("Screenshots")]),_c('div',{staticClass:"demoWrap"},[_c('div',{staticClass:"liveDemo"},[_c('img',{attrs:{"src":_vm.labelContent[_vm.activeIndex].img,"alt":"demo"}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }